import { useRef } from 'react';

export default function useFieldRevealTracker(
  onRevealSuccess: () => void,
  fieldsToLoad: string[],
): (fieldName: string) => () => void {
  const loadedFieldsRef = useRef<Set<string>>(new Set());

  return (fieldName: string) => (): void => {
    loadedFieldsRef.current.add(fieldName);
    if (
      loadedFieldsRef.current.size === fieldsToLoad.length &&
      fieldsToLoad.every((ftl) => loadedFieldsRef.current.has(ftl))
    ) {
      onRevealSuccess();
    }
  };
}
